export default "__VITE_ASSET__B2Z8zAOm__"